<template>
  <camoodoo-page icon="check_circle_outline" title="Compatibility">
    <simple-section dark>
      <div class="page-content">
        <p>
          Here you can find some compatibility information for different
          cameras.
          <b>Even if your camera is not listed here, it may be compatible!</b>
          You can easily test this with the free version of Camoodoo.
        </p>
      </div>
    </simple-section>
    <simple-section light>
      <div class="page-content">
        <q-btn-toggle
          class="vendor-toggles"
          v-model="selectedVendor"
          no-caps
          :options="[
            { label: 'Sony', value: 'SONY' },
            { label: 'Canon', value: 'CANON' },
          ]"
        />
        <q-input v-model="searchTerm" standout placeholder="Search for Camera">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
        <div class="model-list">
          <q-btn
            :color="selectedModelName == modelName ? 'primary' : 'black'"
            v-for="modelName of filteredModelNames"
            :key="modelName"
            no-caps
            @click="selectedModelName = modelName"
            ><span v-html="getModelLabel(modelName)"></span>
          </q-btn>
        </div>
      </div>
    </simple-section>
    <simple-section
      dark
      v-if="selectedModel"
      center
      :title="getFullModelLabel(selectedModelName)"
    >
      <div class="page-content">
        <div class="camera-model-info">
          <div class="feature-group">
            <div class="feature-group-title">Shooting modes</div>
            <div class="feature-group-content">
              <camera-feature name="singleShooting" :data="selectedModel" />
              <camera-feature name="bulbShooting" :data="selectedModel" />
              <camera-feature name="burstShooting" :data="selectedModel" />
              <camera-feature name="movieRecording" :data="selectedModel" />
            </div>
          </div>

          <div class="feature-group">
            <div class="feature-group-title">Exposure controls</div>
            <div class="feature-group-content">
              <camera-feature name="aperture" :data="selectedModel" />
              <camera-feature name="shutterSpeed" :data="selectedModel" />
              <camera-feature name="isoSpeed" :data="selectedModel" />
              <camera-feature
                name="exposureCompensation"
                :data="selectedModel"
              />
            </div>
          </div>

          <div class="feature-group">
            <div class="feature-group-title">Focus controls</div>
            <div class="feature-group-content">
              <camera-feature name="setFocusMode" :data="selectedModel" />
              <camera-feature name="touchFocus" :data="selectedModel" />
              <camera-feature name="manualFocus" :data="selectedModel" />
              <camera-feature name="focusLoupe" :data="selectedModel" />
            </div>
          </div>

          <!-- <div class="feature-group">
            <div class="feature-group-title">Transfer</div>
            <div class="feature-group-content">
              <camera-feature name="transferSmallJpegs" :data="selectedModel" />
              <camera-feature
                name="transferOriginalJpgs"
                :data="selectedModel"
              />
              <camera-feature name="transferRaws" :data="selectedModel" />
            </div>
          </div> -->
        </div>
        <div class="note">
          The information here is based on data I have collected from users.
          There is no guarantee that all information is correct. Please report
          any errors to support.
        </div>
      </div>
    </simple-section>
  </camoodoo-page>
</template>

<script>
import SimpleSection from "@/sections/SimpleSection.vue";
import CamoodooPage from "@/components/CamoodooPage.vue";
import modelDb from "../model/featureData/FeatureDb.json";
//import modelDb from "../model/featureData/FeatureDb";
import CameraFeature from "./CameraFeature.vue";

let vendorLabels = {
  SONY: "Sony",
  CANON: "Canon",
};

export default {
  components: {
    SimpleSection,
    CamoodooPage,
    CameraFeature,
  },
  data() {
    return {
      selectedVendor: "SONY",
      searchTerm: "",
      selectedModelName: null,
      modelOptions: [],
    };
  },
  computed: {
    allModelNames() {
      let models = Object.getOwnPropertyNames(modelDb);
      models.sort();
      return models;
    },
    filteredModelNames() {
      let searchTerm = this.searchTerm.toLowerCase();
      let searchTerms = searchTerm
        .split(" ")
        .map((t) => t.trim())
        .filter((t) => !!t);

      return this.allModelNames
        .filter((m) => modelDb[m].vendor == this.selectedVendor)
        .filter((m) =>
          this.hasTerm(m + " " + this.getFullModelLabel(m), searchTerms)
        );
    },
    selectedModel() {
      if (!this.selectedModelName) return null;
      if (this.filteredModelNames.indexOf(this.selectedModelName) < 0)
        return null;
      return modelDb[this.selectedModelName];
    },
  },
  methods: {
    filterFn(val, update) {
      update(() => {
        this.searchTerm = val ? val.toLowerCase() : null;
      });
    },
    getModelLabel(modelName) {
      let info = modelDb[modelName] || {};
      return info.name || info.model;
    },
    getFullModelLabel(modelName) {
      let info = modelDb[modelName] || {};
      let vendorLabel = vendorLabels[info.vendor];
      let modelLabel = info.name || info.model;
      //      modelLabel = modelLabel.replace("Alpha", "&alpha;");
      return vendorLabel + " " + modelLabel;
    },
    hasTerm(name, searchTerms) {
      console.log(name, searchTerms);
      if (!name) return;
      name = name.toLowerCase();
      for (let term of searchTerms) {
        if (name.indexOf(term) < 0) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  display: flex;
  flex-direction: column;
  gap: 10pt;
  align-items: center;
}
.vendor-toggle {
  border: 1px solid var(--q-color-primary);
}
.camera-model-info + .camera-model-info {
  border-top: 1px solid currentColor;
}
.camera-model-info {
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 15pt;
}
.model-title {
  font-size: 120%;
  font-weight: bold;
}

.model-list {
  display: flex;
  flex-wrap: wrap;
  gap: 11pt;
  justify-content: center;
}

.feature-group {
  border-radius: 10px;
  background: #ffffff0d;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.feature-group-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20pt;
  padding: 10pt;
  justify-content: center;
}

.feature-group-title {
  text-align: center;
  // background: #ffffff1c;
  border-bottom: 1px solid #ffffff24;
  padding: 3pt;
}

.note {
  font-size: 66%;
  opacity: 0.33;
  text-align: center;
}
</style>
